<template>
  <v-card>
    <v-card-text>
      <v-container container--fluid grid-list-md>
         <v-row justify="space-between" align="center">
          <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
            <v-checkbox
              v-if="item.type === 'checkbox'"
              :label="item.text"
              v-model="clientInfo[item.key]"
            ></v-checkbox>
            <v-text-field
              v-if="item.type === 'text'"
              :label="item.text"
              v-model="clientInfo[item.key]"
            ></v-text-field>
            <v-textarea
              v-if="item.type === 'text-area'"
              counter="130"
              :rules="[v => v === null || v === undefined || v.length < 130 || 'Message should contain less than 130 characters including spaces']"
              :label="item.text"
              v-model="clientInfo[item.key]"
            ></v-textarea>
            <v-select
              v-if="item.type === 'select'"
              :items="item.selectItems"
              v-model="clientInfo[item.key]"
              :label="item.text"></v-select>
            <v-menu
              v-if="item.text === 'Silent Start'"
              ref="timeStart"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="clientInfo[item.key]"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="clientInfo[item.key]"
                  :label="item.text"
                  prepend-inner-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="item.ref"
                v-model="clientInfo[item.key]"
                @click:minute="$refs.timeStart[0].save(clientInfo[item.key])"></v-time-picker>
            </v-menu>
            <v-menu
              v-if="item.text === 'Silent End'"
              ref="timeEnd"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="clientInfo[item.key]"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="clientInfo[item.key]"
                  :label="item.text"
                  prepend-inner-icon="access_time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="item.ref"
                v-model="clientInfo[item.key]"
                @click:minute="$refs.timeEnd[0].save(clientInfo[item.key])"></v-time-picker>
            </v-menu>
          </v-col>
         </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  // @group EditClient
  // Client Sms Settings tab for EditClientPage
  export default {
    name: "SmsSettings",
    props: {
      // Client Object
      clientInfo: Object,
    },
    data() {
      return {
        menuStart: false,
        menuEnd: false,
        items: [
          {text: 'Send Transaction SMS', key: 'sms_send', type: 'checkbox'},
          {text: 'Include Image', key: 'sms_include_image', type: 'checkbox'},
          {
            text: 'SMS Number Type',
            key: 'sms_number_type',
            type: 'select',
            selectItems: ['No-Reply', 'Dedicated', 'Generic']
          },
          {text: 'From', key: 'sms_from', type: 'text'},
          {text: 'Use Silent Window', key: 'sms_silent_use', type: 'checkbox'},
          {text: 'Silent Start', key: 'sms_silent_start', type: 'time', ref: 'menuStart'},
          {text: 'Silent End', key: 'sms_silent_end', type: 'time', ref: 'menuEnd'},
          {text: 'Send Pre-route SMS', key: 'sms_pre_route_send', type: 'checkbox'},
          {text: 'Send tracking SMS @8PM', key: 'sms_tracking_send_pm', type: 'checkbox'},
          {text: 'Send tracking SMS @8AM', key: 'sms_tracking_send_am', type: 'checkbox'},
          {text: 'Pre-transaction Message', key: 'pre_transaction_message', type: 'text-area'},
          {text: 'Message', key: 'sms_message', type: 'text-area'},
          {text: 'Tracking Message', key: 'sms_tracking_message', type: 'text-area'},
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/SmsSettings.vue